import type {Component} from 'typings/portaro.fe.types';

class KpSelectableExemplarCardComponentController implements KpSelectableCustomTemplateCardComponentBinding {
    model: any;
    isSelected: boolean;
    customTemplateUrl: string;
}

/**
 * @ngdoc component
 * @name kpSelectableCustomTemplateCard
 * @module uc.record
 *
 * @param {boolean} isSelected
 * @param {any} model
 * @param {string} customTemplateUrl
 *
 * @description
 *
 */
export class KpSelectableCustomTemplateCardComponent implements Component<KpSelectableCustomTemplateCardComponentBinding>{
    public static readonly componentName = 'kpSelectableCustomTemplateCard';

    public bindings = {
        model: '<',
        isSelected: '<',
        customTemplateUrl: '<'
    } as const;

    public templateUrl = require('./kp-selectable-custom-template-card.tpl.ftl');
    public controller = KpSelectableExemplarCardComponentController;
}

interface KpSelectableCustomTemplateCardComponentBinding {
    isSelected: boolean;
    model: any;
    customTemplateUrl: string;
}